import React from 'react'
import PropTypes from 'prop-types'
import BrowserNotSupportedPage from './BrowserNotSupportedPage'
import { browserId } from '../helpers/browserId'

const BrowserCheck = ({ children }) => {
    const { name, version } = browserId()
    const browserIsSupported =
        (name === 'Chrome' && version >= 85) ||
        (name === 'Firefox' && version >= 77) ||
        (name === 'Safari' && version >= 13) ||
        (name === 'Edge' && version >= 85)

    if (!browserIsSupported) {
        console.error(
            `It looks like you're using ${name} ${version} which isn't a supported browser version. If this is a mistake, please contact support and let us know which browser you're using in addition to the one listed here so we can fix this.`,
        )

        return <BrowserNotSupportedPage />
    }

    console.log(
        `It looks like you're using ${name} ${version} which is a supported browser version. Thanks for keeping your browser up-to-date!`,
    )

    return children
}

BrowserCheck.propTypes = {
    children: PropTypes.node.isRequired,
}

export default BrowserCheck
